import profile from '@/config/profile';
import React, { useState, useEffect } from 'react';

const Navigation = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const isLightTheme = profile?.theme === 'light';

  useEffect(() => {
    setIsVisible(true);

    // Handle scroll-based active section detection
    const handleScroll = () => {
      const sections = ['home', 'about', 'work'];
      const scrollPosition = window.scrollY + 100;

      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-1000 transform ${
      isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
    }`}>
      <div className="flex justify-between items-center px-8 py-6">
        <div className={`text-sm font-light tracking-wider hover:text-blue-500 transition-colors duration-300 cursor-pointer ${
          isLightTheme ? 'text-slate-900' : 'text-white'
        }`}>
          {profile?.contact?.name || 'My Portfolio'}
        </div>
        <div className="flex space-x-8">
          {[
            { name: 'ABOUT', id: 'about' },
            { name: 'WORK', id: 'work' },
            { name: 'CONTACT', id: 'contact' }
          ].map((item) => (
            <a
              key={item.name}
              href={`#${item.id}`}
              className={`text-sm font-light tracking-wider transition-all duration-300 hover:text-blue-500 hover:scale-110 ${
                activeSection === item.id ? 'text-blue-500' : isLightTheme ? 'text-slate-800' : 'text-white'
              }`}
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;